import { render, staticRenderFns } from "./Anticheat.vue?vue&type=template&id=033b839e&scoped=true&"
import script from "./Anticheat.vue?vue&type=script&lang=js&"
export * from "./Anticheat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033b839e",
  null
  
)

export default component.exports